import { Component, EventEmitter, HostBinding, HostListener, Inject, Input, Output } from '@angular/core';

import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../base/services/betslip-messages-provider.service';

@Component({
    selector: 'bs-digital-result-slips-details-switcher',
    templateUrl: './result-slips-details-switcher.component.html',
    styleUrls: ['./result-slips-details-switcher.component.scss'],
    standalone: false,
})
export class ResultSlipsDetailsSwitcherComponent {
    @Input() isSlipsDetailsOpen = false;
    @Output() isSlipsDetailsOpenChange = new EventEmitter<boolean>();
    messages: {
        hide: string;
        show: string;
    };

    @HostBinding('class') className = 'betslip-result-slips-details-switcher';

    @HostListener('click') onClick(): void {
        this.isSlipsDetailsOpen = !this.isSlipsDetailsOpen;
        this.isSlipsDetailsOpenChange.emit(this.isSlipsDetailsOpen);
    }

    constructor(@Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messagesProvider: IBetslipMessagesProviderService) {
        const resultMessages = messagesProvider.getMessages().result;
        this.messages = {
            hide: resultMessages.hide,
            show: resultMessages.show,
        };
    }
}
